import { ActionReducerMapBuilder, createReducer, isAnyOf } from '@reduxjs/toolkit'

import { IApplicationsListItem } from 'common/actions/integrations/Applications/interfaces'
import { ApplicationBase } from 'shared/api/common/schemas/applications'
import { ApplicationsApi } from 'shared/api/requests/applications'
import { createAsyncAction } from 'shared/lib/redux'

interface Initial {
  items: IApplicationsListItem[]
  fetching: boolean
}

export const fetchApplications = createAsyncAction('applications/fetch', async () => {
  const { data } = await ApplicationsApi.fetch()
  return data
})

function addItemsCases(builder: ActionReducerMapBuilder<Initial>) {
  builder.addCase(fetchApplications.pending, (state) => {
    state.items = []
  })
  builder.addCase(fetchApplications.fulfilled, (state, action) => {
    state.items = groupApplicationVersions(action.payload.apps)
  })
}

function groupApplicationVersions(applications: ApplicationBase[]) {
  const result: IApplicationsListItem[] = []
  applications.reduce((acc, cur: ApplicationBase) => {
    const item = acc.find((e) => e.app_id === cur.app_id)

    if (item) {
      item.versions.push(cur)
    } else {
      acc.push({ app_id: cur.app_id, versions: [cur] })
    }

    return acc
  }, result)

  return result.sort((a, b) => b.app_id - a.app_id) || []
}

export const reducer = createReducer<Initial>({ items: [], fetching: false }, (builder) => {
  addItemsCases(builder)
  builder.addMatcher(
    isAnyOf(fetchApplications.pending, fetchApplications.fulfilled, fetchApplications.rejected),
    (state, action) => {
      state.fetching = action.type === fetchApplications.pending.type
    },
  )
})
